import * as actions from '../actions'
import { combineReducers } from 'redux';

export function app(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_APP_SETTINGS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}

export function toasts(state = [], action) {
  switch (action.type) {
    case actions.TOAST_SHOW:
      return [
        ...state,
        {
          id: action.payload.id || Date.now(),
          message: action.payload.message,
          type: action.payload.type,
          content: action.payload.data
        }]
    case actions.TOAST_DISMISS:
      return state.filter(toast => toast.id !== action.payload.id)
    default:
      return state;
  }
}

export function modal(state = { modalType: null, modalProps: {}, modalContentProps: {} }, action) {
  switch (action.type) {
    case actions.MODAL_SHOW:
      return {
        ...state.modal,
        modalType: action.payload.modalType,
        modalProps: action.payload.modalProps,
        modalContentProps: action.payload.modalContentProps
      }
    case actions.MODAL_HIDE:
      return {
        ...state.modal,
        modalType: null,
        modalProps: {},
        modalContentProps: {}
      }
    default:
      return state;
  }
}

export function popover(state = { popoverType: null, popoverProps: {} }, action) {
  switch (action.type) {
    case actions.POPOVER_SHOW:
      return {
        ...state.popover,
        popoverType: action.payload.popoverType,
        popoverProps: action.payload.popoverProps
      }
    case actions.POPOVER_HIDE:
      return {
        ...state.popover,
        popoverType: null,
        popoverProps: {}
      }
    default:
      return state;
  }
}

export function download(state = { path: '', packageId: '', fileId: '' }, action) {
  switch (action.type) {
    case actions.INITIATE_DOWNLOAD:
      return {
        ...state.download,
        path: action.payload.path,
        packageId: action.payload.packageId,
        fileId: action.payload.fileId
      }
    case actions.RESET_DOWNLOAD:
      return {
        ...state.download,
        path: '',
        packageId: '',
        fileId: ''
      }
    default:
      return state;
  }
}

export function user(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_USER_DATA:
      return {
        ...action.payload
      }
    default:
      return state;
  }
}

export function portal(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_PORTAL:
      return {
        ...state.portal,
        ...action.payload
      }
    default:
      return state;
  }
}

const contextMenuInitialState = {
  show: false,
  menuItems: [],
  coordinates: { x: 0, y: 0 },
}

export function contextMenu(state = contextMenuInitialState, action) {
  switch (action.type) {
    case actions.CONTEXT_MENU_SHOW:
      return {
        ...state.contextMenu,
        show: true,
        ...action.payload
      }
    case actions.CONTEXT_MENU_HIDE:
      return {
        ...contextMenuInitialState
      }
    default:
      return state;
  }
}

export const rootReducer = combineReducers({
  app,
  user,
  portal,
  toasts,
  modal,
  popover,
  download,
  contextMenu
});